import React, { useState } from 'react';
import { AudioProvider } from './contexts/AudioContext';
import Hero from './components/Hero';
import Quote from './components/Quote';
import CoupleProfile from './components/CoupleProfile';
import EventDetail from './components/EventDetail';
import Countdown from './components/Countdown';
import LoveStory from './components/LoveStory';
import RSVP from './components/RSVP';
import Gift from './components/Gift';
import Footer from './components/Footer';
import Route from './components/Route';

function App() {
  const [showRoute, setShowRoute] = useState(false);

  // Efek untuk menampilkan navegación saat scroll
  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowRoute(true);
      } else {
        setShowRoute(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AudioProvider>
      <div className="relative">
        {showRoute && <Route />}

        <div className="overflow-hidden">
          <div id="Hero"><Hero /></div>
          <div id="Couple"><CoupleProfile /></div>
          <div id="Events"><EventDetail /></div>
          <div id="Quote"><Quote /></div>
          <div id="Story"><LoveStory /></div>
          <div id="Countdown"><Countdown /></div>
          <div id="RSVP"><RSVP /></div>
          <div id="Gift"><Gift /></div>
          <Footer />
        </div>
      </div>
    </AudioProvider>
  );
}

export default App;